(function () {
  function initBlock(blockId, dataScript) {
    var lightbox = document.getElementById('UgcLightbox-' + blockId);
    if (!lightbox) return;

    var items = [];
    try {
      items = JSON.parse(dataScript.textContent);
    } catch (e) {
      items = [];
    }

    var gallery = document.querySelector('.ugc-gallery-' + blockId);
    if (!gallery) return;

    var buttons = Array.prototype.slice.call(gallery.querySelectorAll('.ugc-item[data-ugc-index]'));
    var mediaHost = lightbox.querySelector('[data-ugc-media]');
    var videoPoolHost = gallery.closest('.ugc-gallery-section') || document;
    var videoPool = videoPoolHost.parentElement
      ? videoPoolHost.parentElement.querySelector('[data-ugc-video-source-pool]')
      : document.querySelector('[data-ugc-video-source-pool]');
    var currentIndex = 0;

    function getVideoMarkup(videoId) {
      if (!videoPool) return '';
      var wrap = videoPool.querySelector('[data-ugc-video-id="' + videoId + '"]');
      return wrap ? wrap.innerHTML : '';
    }

    function stopMedia() {
      var video = mediaHost.querySelector('video');
      if (video) video.pause();
      mediaHost.innerHTML = '';
    }

    function renderItem(index) {
      var item = items[index];
      if (!item) return;
      stopMedia();

      if (item.type === 'video' && item.videoId) {
        mediaHost.innerHTML = getVideoMarkup(item.videoId);
        var video = mediaHost.querySelector('video');
        if (video) {
          video.setAttribute('playsinline', '');
          video.autoplay = true;
          video.controls = true;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else if (item.type === 'image' && item.imageUrl) {
        var img = document.createElement('img');
        img.src = item.imageUrl;
        img.alt = item.imageAlt || item.caption || '';
        mediaHost.appendChild(img);
      }

      currentIndex = index;
    }

    function openLightbox(displayIndex) {
      renderItem(displayIndex);
      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = lightbox.querySelector('.ugc-lightbox-close');
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      stopMedia();
      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (buttons[currentIndex]) buttons[currentIndex].focus();
    }

    function showNext(step) {
      var next = (currentIndex + step + items.length) % items.length;
      renderItem(next);
    }

    buttons.forEach(function (btn, displayIndex) {
      btn.addEventListener('click', function () {
        openLightbox(displayIndex);
      });
    });

    lightbox.querySelectorAll('[data-ugc-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    var prevBtn = lightbox.querySelector('[data-ugc-prev]');
    var nextBtn = lightbox.querySelector('[data-ugc-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { showNext(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showNext(1); });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-active')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') showNext(1);
      if (e.key === 'ArrowLeft') showNext(-1);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('script[data-ugc-data]').forEach(function (script) {
      var blockId = script.getAttribute('data-ugc-data');
      initBlock(blockId, script);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();